/**
 * @component {"type":"Audio","version":"1.2"}
 * @component {"type":"Video","version":"1.2"}
 */

define('component-media',['knockout', 'helpers', 'training', 'user-answers', 'media'], function (ko, helpers, Training, UserAnswers, Media) {
    'use strict';

    return function (parentVM, dataContext) {
        var self = this,
            entityVM = parentVM.entity,
            trainingVM = parentVM.training,
            media,
            training = new Training(),
            userAnswers = new UserAnswers();

        self.videoVisible = ko.observable(false);
        self.videoTitle = ko.observable('');

        self.audioInteracted = ko.observable('true');
        self.videoInteracted = ko.observable('true');

        /**
         * Changes audio track of audio element on page
         * @param {Number} index - index of track starting from 0
         */
        self.changeAudioTrack = function (index) {
            setupAudio(index);
        };

        /**
         * Changes video track of video element on page
         * @param {Number} index - index of track starting from 0
         */
        self.changeVideoTrack = function (index) {
            setupVideo(index);
        };

        function setupVideo(index) {

            var ID = entityVM.ID(),
                entity = training.getContent(ID),
                component = helpers.component.getContent(entity.componentsJSON, 'Video'),
                arr = helpers.component.parseProp(component, 'video', 'VideoItem');

            self.videoVisible(false);

            if (!arr.length) {
                return;
            }

            var interacted = (userAnswers.isPageVisited(ID)) ? true : !component.interaction;

            self.videoInteracted(interacted.toString());

            var videoID = 'video-player' + '_' + new Date().getTime(),
                video;

            media = media || new Media({
                training: training
            });

            video = media.parse(arr, index, 'video');

            self.videoTitle(video.name);

            var videoel = document.getElementById('video-element');

            if (video.useframe) {
                videoel.classList.add('videoframe');
                self.videoInteracted(true);
                video.HTML = '<div id="' + videoID + '" class="video-player" ' + video.poster + ' preload="' + video.preload + '" width="auto" height="auto" ' + video.quality + ' >';
                video.HTML += ' </div>';
            } else {
                videoel.classList.remove('videoframe');
                video.HTML = '<video data-title="{title}" id="' + videoID + '" class="video-player" ' + video.poster + ' preload="' + video.preload + '" width="auto" height="auto" ' + video.quality + ' >';
                video.HTML += ' </video>';
            }

            if (!videoel) {
                return;
            }

            videoel.innerHTML = video.HTML;

            if (interacted) {
                media.initVideo(videoID, video, videoel, dataContext.debugMode, null, setPlayer);
            } else {
                media.initVideo(videoID, video, videoel, dataContext.debugMode, trainingVM.updateVisited, setPlayer);
            }

            self.videoVisible(true);

        }

        function setupAudio(index) {

            var ID = entityVM.ID(),
                entity = training.getContent(ID),
                component = helpers.component.getContent(entity.componentsJSON, 'Audio'),
                arr = helpers.component.parseProp(component, 'audio', 'AudioItem');

            if (!arr.length) {
                return;
            }

            var interacted = (userAnswers.isPageVisited(ID)) ? true : !component.interaction;

            self.audioInteracted(interacted.toString());

            var audioID = 'audio-player' + '_' + new Date().getTime(),
                audio;

            media = media || new Media({
                training: training
            });

            audio = media.parse(arr, index, 'audio');

            audio.HTML = '<audio id="' + audioID + '" src="' + audio.source + '" class="audio-js vh" controls preload="' + audio.preload + '" width="auto" height="auto" >';

            audio.HTML += ' </audio>';

            var audioel = document.getElementById('audio-element');

            if (!audioel) {
                return;
            }

            audioel.innerHTML = audio.HTML;

            if (interacted) {
                media.initAudio(audioID, audio, dataContext.debugMode, null, setPlayer);
            } else {
                media.initAudio(audioID, audio, dataContext.debugMode, trainingVM.updateVisited, setPlayer);
            }

        }

        function setPlayer(type,playerRef) {
            switch (type) {
                case "audio":
                    self.audioPlayer = playerRef;
                    break;
                case "video":
                    self.videoPlayer = playerRef;
                    break;
                default:
                    break;
            }
        }

        ko.bindingHandlers.initVideo = {
            update: function () {
                setupVideo(0);
            }
        };

        ko.bindingHandlers.initAudio = {
            update: function () {
                setupAudio(0);
            }
        };
    };

});

